import React from 'react'
import Navbar from '../Componets/Navbar'

const Home = () => {
  return (
    
     <div className="main-content-wrapper d-flex clearfix"> 
     <Navbar/>
        <div className="products-catagories-area clearfix">
            <div className="amado-pro-catagory clearfix masonry-gallery">

            
                <div className="single-products-catagory clearfix">
                
                    <a href="shop">
                        <img src="img/bg-img/1.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $180</p>
                            <h4>Modern Chair</h4>
                        </div>
                    </a>
                </div>
                
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/2.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $180</p>
                            <h4>Minimalistic Plant Pot</h4>
                        </div>
                    </a>
                </div>
                
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/3.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $180</p>
                            <h4>Modern Chair</h4>
                        </div>
                    </a>
                </div>
               

              
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/4.jpg" alt=""/>
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $180</p>
                            <h4>Night Stand</h4>
                        </div>
                    </a>
                </div>
                
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/5.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $18</p>
                            <h4>Plant Pot</h4>
                        </div>
                    </a>
                </div>
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/6.jpg" alt=""/>
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $320</p>
                            <h4>Small Table</h4>
                        </div>
                    </a>
                </div>
              

               
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/7.jpg" alt=""/>
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $318</p>
                            <h4>Metallic Chair</h4>
                        </div>
                    </a>
                </div>
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/8.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $318</p>
                            <h4>Modern Rocking Chair</h4>
                        </div>
                    </a>
                </div>
                
                <div className="single-products-catagory clearfix">
                    <a href="shop">
                        <img src="img/bg-img/9.jpg" alt=""/>
                        
                        <div className="hover-content">
                            <div className="line"></div>
                            <p>From $318</p>
                            <h4>Home Deco</h4>
                        </div>
                    </a>
                </div>
                </div>
            </div>
        </div>
        


    
  )
}

export default Home;